import React, { createContext, ReactNode } from 'react'
import {
  ObjMusic,
  ObjGitRepos,
  ObjResume,
  DocsManager,
  ObjPortfolio,
  SidebarPageManager,
  SlideshowManager,
  TechNotesManager,
  TalksManager,
} from '../managers'

interface iManagersContext {
  objResume: ObjResume | Record<string, never>
  objGitRepos: ObjGitRepos | Record<string, never>
  objMusic: ObjMusic | Record<string, never>
  objPortfolio: ObjPortfolio | Record<string, never>
  sidebarPageManager: SidebarPageManager | Record<string, never>
  slideshowManager: SlideshowManager | Record<string, never>
  docsManager: DocsManager | Record<string, never>
  techNotesManager: TechNotesManager | Record<string, never>
  talksManager: TalksManager | Record<string, never>
}
const initialStarter: iManagersContext = {
  objResume: {},
  objGitRepos: {},
  objMusic: {},
  objPortfolio: {},
  sidebarPageManager: {},
  slideshowManager: {},
  docsManager: {},
  techNotesManager: {},
  talksManager: {},
}

const ManagersContext = createContext<iManagersContext>(initialStarter)
interface iManagersProviderProps {
  children: ReactNode
}
export function ManagersProvider(props: iManagersProviderProps) {
  const objMusic = new ObjMusic()
  objMusic.loadData()
  const objGitRepos = new ObjGitRepos()
  objGitRepos.loadData()
  const objResume = new ObjResume()
  const docsManager = new DocsManager()
  const techNotesManager = new TechNotesManager()
  techNotesManager.loadData()
  const objPortfolio = new ObjPortfolio()
  objPortfolio.loadData()
  const sidebarPageManager = new SidebarPageManager(
    docsManager,
    techNotesManager
  )
  sidebarPageManager.load()
  const slideshowManager = new SlideshowManager()
  slideshowManager.lazyLoad()
  const talksManager = new TalksManager()
  talksManager.load()

  return (
    <ManagersContext.Provider
      value={{
        objResume,
        objGitRepos,
        objMusic,
        objPortfolio,
        sidebarPageManager,
        slideshowManager,
        docsManager,
        techNotesManager,
        talksManager,
      }}
    >
      {props.children}
    </ManagersContext.Provider>
  )
}
export default ManagersContext
